const p = (path: string) => `/images/${path}`;

const images = {
  logo: p("findMojo.png"),
  iconAchievers: p("IconAchievers.png"),
  iconBuilders: p("IconBuilders.png"),
  iconCaregivers: p("IconCaregivers.png"),
  iconRewards: p("IconRewards.png"),
  iconThinkers: p("IconThinkers.png"),
  iconWheel: p("IconWheel.png"),
  iconWheelWhite: p("IconWheelWhite.png"),
  maCover: p("MA_Cover.png"),
};
export default images;
